import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const transactionsSlice = createSlice({
    name: 'ui/transactions',
    initialState: { ...initialState },
    reducers: listReducers
})

export const transactionsActions = transactionsSlice.actions
export default transactionsSlice.reducer
